import country from "fragments/vendors/country"
import { gql } from "graphql-tag"

const GET_COUNTRIES = gql`
  ${country}

  query getCountries($query: GetQueryCountries) {
    getCountries(query: $query) {
      ...Country
    }
  }
`

export default GET_COUNTRIES
